import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpsertHlSecurityMappingInput } from 'shared';

import {
  deleteHlSecurityMapping,
  updateHlSecurityMapping,
  upsertHlSecurityMapping,
} from '../../lib/api/endpoints';

import { hlSecurityMappingKeys } from './queries';

export function useUpsertHlSecurityMapping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpsertHlSecurityMappingInput) => upsertHlSecurityMapping(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: hlSecurityMappingKeys.all });
    },
  });
}

export function useUpdateHlSecurityMapping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; body: UpsertHlSecurityMappingInput }) =>
      updateHlSecurityMapping(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: hlSecurityMappingKeys.all });
    },
  });
}

export function useDeleteHlSecurityMapping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteHlSecurityMapping(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: hlSecurityMappingKeys.all });
    },
  });
}
